import React from "react"
const PageNotFound: React.FC = () => {
    return (
        <h3>Page Not Found!</h3>
    )
}

export default PageNotFound;